import { Component, OnInit, ViewChildren, QueryList, ViewChild } from '@angular/core';
import { CertificationCategoryServiceServiceProxy, CCertificationDto, CertificationServiceServiceProxy, CCategoryAnswerDto, FarmerServiceServiceProxy, FarmerDto, CAnswerLevelEnum, FarmerCropQuantityServiceServiceProxy, FarmerNutrientRecommendationQuantityServiceServiceProxy, FarmerNutrientRecommendationQuantityDto, FarmerCropQuantityDto, CBehaviorTypeEnum, CCertificationStatusEnum, FarmerNutrientSourceQuantityDto, FarmerNutrientSourceQuantityServiceServiceProxy } from '@shared/service-proxies/service-proxies';
import { AppStorageService } from '@shared/storage/app-storage.service';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { AlertController, LoadingController, IonCard, IonContent, NavController, ModalController } from '@ionic/angular';
import { AppSessionService } from '@shared/session/app-session.service';
import { CertificationCategoryComponent } from './certification-category/certfication-category.component';
import { AccordionPanelComponent } from 'src/app/components/accordion/accordion-panel/accordion-panel.component';
import { CertificationMasterSectionEnum } from './model/certification-master-section-enum';
import { AppThemeColors } from 'src/app/app-theme-colors-enum';
import { PermissionCheckerService } from '@shared/auth/permission-checker.service';
import { Title } from '@angular/platform-browser';
import { CertificationValidationPage } from './certification-validation/certification-validation.page';


@Component({
  selector: 'app-certification',
  templateUrl: './certification.page.html',
  styleUrls: ['./certification.page.scss'],
})
export class CertificationPage implements OnInit  {

  id: number = 0;
  certification: CCertificationDto;
  farmer: FarmerDto;
  farmerCrops: FarmerCropQuantityDto[];
  farmerNutrientSources: FarmerNutrientSourceQuantityDto[];
  farmerNutrientRecommendations: FarmerNutrientRecommendationQuantityDto[];
  answerLevels: number[] = [];
  categories: CCategoryAnswerDto[] = [];
  isLoaded: boolean = false;
  isView: boolean = false;

  @ViewChild(IonContent, {static: false}) content: IonContent;
  @ViewChildren('topLevelPanels') topLevelPanels: QueryList<CertificationCategoryComponent>;
  constructor(
    private certificationService: CertificationServiceServiceProxy,
    private certificationCategoryService: CertificationCategoryServiceServiceProxy,
    storageService: AppStorageService,
    private route: ActivatedRoute,
    private router: Router,
    private loadingController: LoadingController,
    private alertController: AlertController,
    private farmerSvc: FarmerServiceServiceProxy,
    private farmerCropQuantityServiceService: FarmerCropQuantityServiceServiceProxy,
    private farmerNutrientSourceQuantityService: FarmerNutrientSourceQuantityServiceServiceProxy,
    private farmerNutrientRecommendationQuantityService: FarmerNutrientRecommendationQuantityServiceServiceProxy,
    private permissionChecker: PermissionCheckerService,
    private titleService: Title,
    private navCtrl: NavController,
    private modalController: ModalController
  ) {
    storageService.IsLoadedSubject.subscribe(x => { 
      if (!this.isLoaded && x) {
        this.route.queryParams.subscribe(params => {
          if (params && params.isView) {
            this.isView = params.isView == 'true';
          }
          if (params && params.farmer) {
            this.farmer = JSON.parse(params.farmer);
            this.determineAnswerLevels();
          }
          if (params && params.farmerCrops) {
            this.farmerCrops = JSON.parse(params.farmerCrops);
            if (this.farmerCrops) {
              this.farmerCrops = this.farmerCrops.filter(x => x.quantity > 0);
            }
          }
          if (params && params.farmerNutrientSources) {
            this.farmerNutrientSources = JSON.parse(params.farmerNutrientSources);
          }
          if (params && params.farmerNutrientRecommendations) {
            this.farmerNutrientRecommendations = JSON.parse(params.farmerNutrientRecommendations);
          }
          if (params && params.certificationId) {
            this.id = +params.certificationId;
            if (this.id > 0) { // id is required
              this.getCertification();
            }
          }
          this.isLoaded = true;
        });
      }
    });
    this.titleService.setTitle('OACI - Certification');
  }

  ngOnInit() {
    
  }

  ionViewWillEnter() {

  }

  async getCertification() {
    
    const loading = await this.loadingController.create({
      message: 'Fetching certification...',
    });
    await loading.present();

    this.certificationService.get(this.id).subscribe(async certification => {
      this.certification = certification;
      if (this.certification) {
        if (
          !this.isView &&
          this.certification.statusId == CCertificationStatusEnum._2 &&
          !this.isAdmin()
        ) {
          await loading.dismiss();

          const alert = await this.alertController.create({
            header: 'Error',
            message: 'This certification has already been completed. Redirecting to certification score page.',
            buttons: [
              {
                text: 'Okay',
                handler: () => {
                  const navigationExtras: NavigationExtras = {
                    queryParams: {
                      certificationId: this.id
                    }
                  };
                  this.router.navigate(['/main/certification-score'], navigationExtras);
                }
              }
            ]
          });

          await alert.present();
          return;
        }
        if (!this.farmer) {
          this.getFarmer();
        }
        if (!this.farmerCrops) {
          this.getFarmerCrops();
        }
        if (!this.farmerNutrientSources) {
          this.getFarmerNutrientSources();
        }
        if (!this.farmerNutrientRecommendations) {
          this.getFarmerNutrientRecommendations();
        }
        this.certificationCategoryService.getCategories(this.id).subscribe(async x => {
          // x[0].children[0].collapsed = false;
          this.categories = x;
          await loading.dismiss();
        });
      }
    });
  }

  getFarmer() {
    this.farmerSvc.get(this.certification.farmerId).subscribe(farmer => {
      this.farmer = farmer;
      this.determineAnswerLevels();
    });
  }

  determineAnswerLevels() {
    if (this.farmer) {
      if (this.farmer.ownedAcres && this.farmer.ownedAcres > 0) {
        this.answerLevels.push(CAnswerLevelEnum._0);
      }
      if (this.farmer.rentedAcres && this.farmer.rentedAcres > 0) {
        this.answerLevels.push(CAnswerLevelEnum._1);
      }
    }
  }

  getFarmerCrops() {
    this.farmerCropQuantityServiceService.getAllByFarmerId(this.certification.farmerId).subscribe(farmerCrops => {
      this.farmerCrops = farmerCrops.filter(x => x.quantity > 0);
    });
  }

  getFarmerNutrientSources() {
    this.farmerNutrientSourceQuantityService.getAllByFarmerId(this.certification.farmerId).subscribe(farmerNSs => {
      this.farmerNutrientSources = farmerNSs;
    });
  }

  getFarmerNutrientRecommendations() {
    this.farmerNutrientRecommendationQuantityService.getAllByFarmerId(this.certification.farmerId).subscribe(farmerNRs => {
      this.farmerNutrientRecommendations = farmerNRs;
    });
  }

  // collapseExcept(panelToCollapse: AccordionPanelComponent){
  //   this.topLevelPanels.forEach(topLevelPanel => {
  //     topLevelPanel.categoryLevelPanels.forEach(categoryLevelPanel => {
  //       if(categoryLevelPanel.accordion.hasPanel(panelToCollapse)) {
  //         if (panelToCollapse.collapsed) {
  //           categoryLevelPanel.accordion.collapse(panelToCollapse);
  //         }
  //       } else {
  //         categoryLevelPanel.accordion.closeAll();
  //       }
  //     });
  //   });
  // }

  cancel() {
    this.navCtrl.back();
    // this.router.navigate(['/main/home']);
  }

  setInProgress() {
    
    this.certification.statusId = CCertificationStatusEnum._1;
    this.certificationService.save(this.certification).subscribe();

  }

  async complete(didValidate: boolean) {

    if (!didValidate) {
      const missingFields = this.validateForMissingFields();
      if (missingFields) {
        
        const modal = await this.modalController.create({
          component: CertificationValidationPage,
          componentProps: {
            'missingFields': missingFields,
          }
        });
        modal.onDidDismiss().then((param) => {
          if (param && param.data && param.data['didConfirm'] == true) {
            this.complete(true);
          }
        });
        return await modal.present();

        // const alert = await this.alertController.create({
        //   header: 'Certification Validation',
        //   message: missingFields,
        //   buttons: [
        //     {
        //       text: 'No',
        //       role: 'cancel',
        //       cssClass: 'secondary',
        //       handler: (blah) => {
                
        //       }
        //     }, {
        //       text: 'Yes',
        //       handler: async () => {
        //         this.complete(true);
        //       }
        //     }
        //   ]
        // });
        // await alert.present();
      return;
      }
    }

    const loading = await this.loadingController.create({
      message: 'Completing Certification...',
    });
    await loading.present();
    
    this.certification.statusId = CCertificationStatusEnum._2;
    this.certification.ownedAcres = this.farmer.ownedAcres;
    this.certification.rentedAcres = this.farmer.rentedAcres;
    this.certificationService.save(this.certification).subscribe(
      async certification => {
        
        await loading.dismiss();
        
        const navigationExtras: NavigationExtras = {
          queryParams: {
            certificationId: this.id
          }
        };
        
        this.router.navigate(['/main/certification-score'], navigationExtras);

      },
      async error => {
        this.saveError(error).then();
        await loading.dismiss();
      }
    );
  }

  // Format (ex):
  // Nutrient Application RATE:
  // > Soil Test Frequency
  //   • Owned - Expected: ** - Actual: ** 
  validateForMissingFields() {
    let missingFields = '';
    const topLevelCategoryAdded = [];
    if (!this.categories) return;
    this.categories.forEach(topLevelCategory => {
      topLevelCategory.children.forEach(category => {
        const categoryAdded = [];
        if (this.shouldShowCategory(category.id) && !this.isBonusQuestion(category.id)) {
          if (this.shouldShowOwned(category.id)) {
            let hasEnteredAnswer = false, isCropCategory = false;
            const cropIdsHaveEntered = [];
            category.children.forEach(categoryQuestion => {
              if (categoryQuestion.behaviorTypeId == 2) {
                if (categoryQuestion.answerTypeId == 1) {
                  if (
                    categoryQuestion.answers &&
                    categoryQuestion.answers.owned &&
                    categoryQuestion.answers.owned[0] &&
                    categoryQuestion.answers.owned[0].answer &&
                    categoryQuestion.answers.owned[0].answer == "true"
                  ) {
                    hasEnteredAnswer = true;
                  }
                }
                if (categoryQuestion.answerTypeId == 2) {
                  if (
                    categoryQuestion.answers &&
                    categoryQuestion.answers.owned &&
                    categoryQuestion.answers.owned[0] &&
                    categoryQuestion.answers.owned[0].answer &&
                    parseFloat(categoryQuestion.answers.owned[0].answer) > -1
                  ) {
                    hasEnteredAnswer = true;
                  }
                }
              }
              if (categoryQuestion.behaviorTypeId == 3) {
                isCropCategory = true;
                this.farmerCrops.forEach(farmerCrop => {
                  if (this.shouldShowCrop(category.id, farmerCrop.cropId)) {
                    if (categoryQuestion.answerTypeId == 1) {
                      if (
                        categoryQuestion.answers &&
                        categoryQuestion.answers.owned &&
                        categoryQuestion.answers.owned.find(x => x.objectId == farmerCrop.cropId) &&
                        categoryQuestion.answers.owned.find(x => x.objectId == farmerCrop.cropId).answer &&
                        categoryQuestion.answers.owned.find(x => x.objectId == farmerCrop.cropId).answer == "true"
                      ) {
                        if (cropIdsHaveEntered.indexOf(farmerCrop.cropId) == -1) cropIdsHaveEntered.push(farmerCrop.cropId);
                      }
                    }
                    if (categoryQuestion.answerTypeId == 2) {
                      if (
                        categoryQuestion.answers &&
                        categoryQuestion.answers.owned &&
                        categoryQuestion.answers.owned.find(x => x.objectId == farmerCrop.cropId) &&
                        categoryQuestion.answers.owned.find(x => x.objectId == farmerCrop.cropId).answer &&
                        parseFloat(categoryQuestion.answers.owned.find(x => x.objectId == farmerCrop.cropId).answer) > -1
                      ) {
                        if (cropIdsHaveEntered.indexOf(farmerCrop.cropId) == -1) cropIdsHaveEntered.push(farmerCrop.cropId);
                      }
                    }
                  }
                });

              }
            });
            if (!isCropCategory) {
              if (!hasEnteredAnswer) {
                if (topLevelCategoryAdded.indexOf(topLevelCategory.label) == -1) {
                  if (!missingFields) missingFields = topLevelCategory.label + ":";
                  else missingFields = missingFields + "<br>" + topLevelCategory.label + ":";
                  topLevelCategoryAdded.push(topLevelCategory.label);
                } 
                if (categoryAdded.indexOf(category.label) == -1) {
                  missingFields = missingFields + "<br>&nbsp;<b>-</b>&nbsp;" + category.label + " (Owned)";
                  categoryAdded.push(category.label);
                }
              }
            } else {
              if (cropIdsHaveEntered.length != this.farmerCrops.length) {
                const cropsNotEntered = this.farmerCrops.filter(x => cropIdsHaveEntered.indexOf(x.cropId) == -1);
                cropsNotEntered.forEach(cropNotEntered => {
                  if (this.shouldShowCrop(category.id, cropNotEntered.cropId)) {
                    if (topLevelCategoryAdded.indexOf(topLevelCategory.label) == -1) {
                      if (!missingFields) missingFields = topLevelCategory.label + ":";
                      else missingFields = missingFields + "<br>" + topLevelCategory.label + ":";
                      topLevelCategoryAdded.push(topLevelCategory.label);
                    } 
                    if (categoryAdded.indexOf(category.label) == -1) {
                      missingFields = missingFields + "<br>&nbsp;<b>-</b>&nbsp;" + category.label + ":";
                      categoryAdded.push(category.label);
                    }
                    missingFields = missingFields + "<br>&nbsp;&nbsp;&nbsp;• " + cropNotEntered.cropName;
                  }
                });
              }
            }
          }
          if (this.shouldShowRented(category.id)) {
            let hasEnteredAnswer = false, isCropCategory = false;
            const cropIdsHaveEntered = [];
            category.children.forEach(categoryQuestion => {
              if (categoryQuestion.behaviorTypeId == 2) {
                if (categoryQuestion.answerTypeId == 1) {
                  if (
                    categoryQuestion.answers &&
                    categoryQuestion.answers.rented &&
                    categoryQuestion.answers.rented[0] &&
                    categoryQuestion.answers.rented[0].answer &&
                    categoryQuestion.answers.rented[0].answer == "true"
                  ) {
                    hasEnteredAnswer = true;
                  }
                }
                if (categoryQuestion.answerTypeId == 2) {
                  if (
                    categoryQuestion.answers &&
                    categoryQuestion.answers.rented &&
                    categoryQuestion.answers.rented[0] &&
                    categoryQuestion.answers.rented[0].answer &&
                    parseFloat(categoryQuestion.answers.rented[0].answer) > -1
                  ) {
                    hasEnteredAnswer = true;
                  }
                }
              }
              if (categoryQuestion.behaviorTypeId == 3) {
                isCropCategory = true;
                this.farmerCrops.forEach(farmerCrop => {
                  if (this.shouldShowCrop(category.id, farmerCrop.cropId)) {
                    if (categoryQuestion.answerTypeId == 1) {
                      if (
                        categoryQuestion.answers &&
                        categoryQuestion.answers.rented &&
                        categoryQuestion.answers.rented.find(x => x.objectId == farmerCrop.cropId) &&
                        categoryQuestion.answers.rented.find(x => x.objectId == farmerCrop.cropId).answer &&
                        categoryQuestion.answers.rented.find(x => x.objectId == farmerCrop.cropId).answer == "true"
                      ) {
                        if (cropIdsHaveEntered.indexOf(farmerCrop.cropId) == -1) cropIdsHaveEntered.push(farmerCrop.cropId);
                      }
                    }
                    if (categoryQuestion.answerTypeId == 2) {
                      if (
                        categoryQuestion.answers &&
                        categoryQuestion.answers.rented &&
                        categoryQuestion.answers.rented.find(x => x.objectId == farmerCrop.cropId) &&
                        categoryQuestion.answers.rented.find(x => x.objectId == farmerCrop.cropId).answer &&
                        parseFloat(categoryQuestion.answers.rented.find(x => x.objectId == farmerCrop.cropId).answer) > -1
                      ) {
                        if (cropIdsHaveEntered.indexOf(farmerCrop.cropId) == -1) cropIdsHaveEntered.push(farmerCrop.cropId);
                      }
                    }
                  }
                });

              }
            });
            if (!isCropCategory) {
              if (!hasEnteredAnswer) {
                if (topLevelCategoryAdded.indexOf(topLevelCategory.label) == -1) {
                  if (!missingFields) missingFields = topLevelCategory.label + ":";
                  else missingFields = missingFields + "<br>" + topLevelCategory.label + ":";
                  topLevelCategoryAdded.push(topLevelCategory.label);
                } 
                if (categoryAdded.indexOf(category.label) == -1) {
                  missingFields = missingFields + "<br>&nbsp;<b>-</b>&nbsp;" + category.label + " (Rented)";
                  categoryAdded.push(category.label);
                }
              }
            } else {
              if (cropIdsHaveEntered.length != this.farmerCrops.length) {
                const cropsNotEntered = this.farmerCrops.filter(x => cropIdsHaveEntered.indexOf(x.cropId) == -1);
                cropsNotEntered.forEach(cropNotEntered => {
                  if (this.shouldShowCrop(category.id, cropNotEntered.cropId)) {
                    if (topLevelCategoryAdded.indexOf(topLevelCategory.label) == -1) {
                      if (!missingFields) missingFields = topLevelCategory.label + ":";
                      else missingFields = missingFields + "<br>" + topLevelCategory.label + ":";
                      topLevelCategoryAdded.push(topLevelCategory.label);
                    } 
                    if (categoryAdded.indexOf(category.label) == -1) {
                      missingFields = missingFields + "<br>&nbsp;<b>-</b>&nbsp;" + category.label + ":";
                      categoryAdded.push(category.label);
                    }
                    missingFields = missingFields + "<br>&nbsp;&nbsp;&nbsp;• " + cropNotEntered.cropName;
                  }
                });
              }
            }
          }
        }
      });
    });
    // console.log(missingFields);
    return missingFields;
  }

  async saveError(errorMessage) {
    const alert = await this.alertController.create({
      header: 'Error',
      subHeader: 'Error',
      message: errorMessage,
      buttons: ['OK']
    });

    await alert.present();
  }

  didLoad() {
    return this.id > 0 && this.categories.length > 0;
  }
  
  shouldShowOwned(categoryId: number): boolean {
    return (
      (this.answerLevels.includes(0) && this.shouldShowCategoryByAnswerLevel(categoryId, 0))
      ||
      (this.isCropQuestion(categoryId) && this.hasFarmerCrops())
      ||
      this.isBonusQuestion(categoryId)
    );
  }
  shouldShowOwnedLabel(categoryId: number): boolean {
    return !this.isCropQuestion(categoryId) &&
    !this.isManureApplication(categoryId) &&
    !this.isBonusQuestion(categoryId);
  }
  shouldShowRented(categoryId: number): boolean {
    return this.answerLevels.includes(1) &&
      !this.isCropQuestion(categoryId) &&
      !this.isBonusQuestion(categoryId) &&
      this.shouldShowCategoryByAnswerLevel(categoryId, 1);
  }
  shouldShowRentedLabel(categoryId: number): boolean {
    return !this.isCropQuestion(categoryId) &&
      !this.isManureApplication(categoryId) &&
      !this.isBiosolidsApplication(categoryId) &&
      !this.isOtherOrganic(categoryId) &&
      !this.isBonusQuestion(categoryId);
  }
  shouldShowCategoryByAnswerLevel(categoryId: number, answerLevel: number) {
    switch(categoryId) {
      case 10: // Commercial Phosphorus Fertilizer Recommendations
      case 11: // Commercial Nitrogen Fertilizer Recommendations
      case 12: // Commercial Phosphorus Fertilizer Application
      case 13: // Commercial Nitrogen Fertilizer Application
        const fns = this.farmerNutrientSources.find(x => x.nutrientSourceId == 1);
        return fns ? answerLevel == 0 ? fns.ownedQuantity > 0 : fns.rentedQuantity > 0 : false;
      case 7: // Manure Application Recommendation
      case 14: // Manure Application
        const mns = this.farmerNutrientSources.find(x => x.nutrientSourceId == 2);
        return mns ? answerLevel == 0 ? mns.ownedQuantity > 0 : mns.rentedQuantity > 0 : false;
      case 8: // Biosolids Application Recommendation
      case 15: // Biosolids Application
        const bns = this.farmerNutrientSources.find(x => x.nutrientSourceId == 3);
        return bns ? answerLevel == 0 ? bns.ownedQuantity > 0 : bns.rentedQuantity > 0 : false;
      case 9: // Other Organic Nutrient Sources
      case 16: // Other Organic Sources
        const ons = this.farmerNutrientSources.find(x => x.nutrientSourceId == 6);
        return ons ? answerLevel == 0 ? ons.ownedQuantity > 0 : ons.rentedQuantity > 0 : false;
      default:
        return true;
    }
  }
  shouldShowCrop(categoryId: number, cropId: number) {
    if ([
      11, // Commercial Nitrogen Fertilizer Recommendations
      13  // Commercial Nitrogen Fertilizer Application
    ].indexOf(categoryId) > -1) {
      return cropId != 11 // Soy
    } else return true;
  }
  isCropQuestion(categoryId: number) {
    return [
      10, // Commercial Phosphorus Fertilizer Recommendations
      11, // Commercial Nitrogen Fertilizer Recommendations
      12, // Commercial Phosphorus Fertilizer Application
      13, // Commercial Nitrogen Fertilizer Application
      17  // Tillage
    ].indexOf(categoryId) > -1;
  }
  isManureApplication(categoryId: number) {
    return [
      7,  // Manure Application Recommendation
      14, // Manure Application
    ].indexOf(categoryId) > -1;
  }
  isBiosolidsApplication(categoryId: number) {
    return [
      8,  // Biosolids Application Recommendation
      15, // Biosolids Application
    ].indexOf(categoryId) > -1;
  }
  isOtherOrganic(categoryId: number) {
    return [
      9,  // Other Organic Nutrient Sources
      16, // Other Organic Sources
    ].indexOf(categoryId) > -1;
  }

  isBonusQuestion(categoryId: number) {
    return [
      19, // Grassed Waterways
      20, // Grade Stabilization Structures
      21, // Blind Inlets
      22, // Drainage Water Control Structures
      23, // Filter Strips or Buffer Strips
      24, // Wetlands
      25, // Two-Stage Ditch or Natural Stream Channel Restoration
      26, // Denitrifying Bioreactor
      27  // Phosphorus Removal Bed (P-filter)
    ].indexOf(categoryId) > -1;
  }

  getFarmerNutrientSource (category: CCategoryAnswerDto) {
    switch(category.id) {
      case 7: // Manure Application Recommendation
      case 14: // Manure Application
        return this.farmerNutrientSources.find(x => x.nutrientSourceId == 2);
      case 8: // Biosolids Application Recommendation
      case 15: // Biosolids Application
        return this.farmerNutrientSources.find(x => x.nutrientSourceId == 3);
      case 9: // Other Organic Nutrient Sources
      case 16: // Other Organic Sources
        return this.farmerNutrientSources.find(x => x.nutrientSourceId == 6);
      default: return null;
    }
  }
  getCategoryColor(category: CCategoryAnswerDto) {
    switch(category.id) {
      case CertificationMasterSectionEnum.NutrientApplicationRate:
        return AppThemeColors.OliveGreen;
      case CertificationMasterSectionEnum.NutrientApplicationPlacement:
        return AppThemeColors.DarkCyan;
      case CertificationMasterSectionEnum.InFieldManagement:
        return AppThemeColors.BabyBlue;
      case CertificationMasterSectionEnum.StructuralPractices:
        return AppThemeColors.Purple;
    }
  }

  public toggle(category: CCategoryAnswerDto)
  {
    this.categories.forEach(c => {
      c.children.forEach(child => {
        if (c.id == category.parentId) {
          if (child.id != category.id) {
            child.collapsed = true;
          } else {
            child.collapsed = !child.collapsed;
          }
        } else {
          child.collapsed = true;
        }
      });
    });

    setTimeout(() => {
      this.scrollToTop(category.id.toString()); 
    }, 100);
  }

  scrollToTop(id: string){
    //Scroll accordion list item to top
    let doc = document.getElementById(id);
    doc.scrollIntoView({ block: 'start',  behavior: 'smooth' });
  }

  public collapseExcept(category: CCategoryAnswerDto)
  {
    this.categories.forEach(c => {
      c.children.forEach(child => {
        if (c.id == category.parentId) {
          if (child.id != category.id) {
            child.collapsed = true;
          } else {
            child.collapsed = false
          }
        } else {
          child.collapsed = true;
        }
      });
    });
  }

  shouldShowCategory(categoryId: number) {
    switch(categoryId) {
      case 10: // Commercial Phosphorus Fertilizer Recommendations
      case 11: // Commercial Nitrogen Fertilizer Recommendations
      case 12: // Commercial Phosphorus Fertilizer Application
      case 13: // Commercial Nitrogen Fertilizer Application
        const fns = this.farmerNutrientSources.find(x => x.nutrientSourceId == 1);
        return fns ? fns.ownedQuantity > 0 || fns.rentedQuantity > 0 : false;
      case 7: // Manure Application Recommendation
      case 14: // Manure Application
        const mns = this.farmerNutrientSources.find(x => x.nutrientSourceId == 2);
        return mns ? mns.ownedQuantity > 0 || mns.rentedQuantity > 0 : false;
      case 8: // Biosolids Application Recommendation
      case 15: // Biosolids Application
        const bns = this.farmerNutrientSources.find(x => x.nutrientSourceId == 3);
        return bns ? bns.ownedQuantity > 0 || bns.rentedQuantity > 0 : false;
      case 9: // Other Organic Nutrient Sources
      case 16: // Other Organic Sources
        const ons = this.farmerNutrientSources.find(x => x.nutrientSourceId == 6);
        return ons ? ons.ownedQuantity > 0 || ons.rentedQuantity > 0 : false;
      default:
        return true;
    }
  }

  isAdmin() {
    return this.permissionChecker.isGranted("Pages.Certifications");
  }

  hasFarmerCrops() {
    return this.farmerCrops && this.farmerCrops.length > 0;
  }

  back() {
    const navigationExtras: NavigationExtras = {
      queryParams: {
        farmerId: this.farmer.id
      }
    };
    this.router.navigate(['/main/farmer'], navigationExtras);
  }

  isBooleanQuestion(category: CCategoryAnswerDto) {
    return category ? category.children ? category.children[0] ? category.children[0].answerTypeId == 1 : false : false : false;
  }

}
